import AuthManager from '@/auth';
import router from '@/router/index';
import store from './store/index';

export const UserMenuItems = [
  {
    icon: 'account_circle',
    href: 'Profile',
    title: 'Profile',
    // tslint:disable-next-line:no-empty
    click: () => {
      router.push({name: 'profile'});
    },
  },
  // {
  //   icon: 'settings',
  //   href: '#',
  //   title: 'Settings',
  //   // tslint:disable-next-line:no-empty
  //   click: () => {
  //   },
  // },
  {
    icon: 'power_settings_new',
    href: '/',
    title: 'Logout',
    // tslint:disable-next-line:no-empty
    click: () => {
      AuthManager.Instance.signOut();
    },
  },
];

